<template>
    <div id="main-container" class="px-0">
        <div class="scrollable-container" style="overflow-y: scroll;">
            <div class="button-container">
                <div class="d-flex align-items-center">
                    <font-awesome-icon icon="arrow-left" class="text-main" @click="goBack"
                        style="cursor: pointer; margin-top: 3px;" />
                    <span class="text-main font-weight-bold ml-2" @click="goBack" style="cursor: pointer;">{{ $t('Cancel')
                    }}</span>
                </div>
            </div>
            <div class="card card-container">
                <img id="img-card" class="img-card" src="@/assets/images/logo-forgotpassword.png" />
                <h3 id="header-title" class="text-main font-weight-bold mt-3">{{ $t('Reset Password') }}</h3>
                <Form @submit="handleRegister" :validation-schema="schema" :initial-values="initialValues">
                    <Field name="resetToken" type="hidden" class="form-control" />
                    <label for="password">{{ $t('Please enter your new password') }}</label>
                    <div class="form-group">
                        <div class="input-group">
                            <Field name="password" type="password" class="form-control" :placeholder="$t('Password')" />
                            <div class="input-group-prepend d-flex align-items-center pl-3">
                                <font-awesome-icon :icon="iconToggle" @click.prevent="togglePassword"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                        <ErrorMessage name="password" class="error-feedback" />
                    </div>
                    <div class="form-group">
                        <div class="input-group">
                            <Field name="confirmPassword" type="password" class="form-control"
                                :placeholder="$t('Confirm Password')" />
                            <div class="input-group-prepend d-flex align-items-center pl-3">
                                <font-awesome-icon :icon="iconToggleConfirm" @click.prevent="toggleConfirmPassword"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                        <ErrorMessage name="confirmPassword" class="error-feedback" />
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-main btn-block" :disabled="loading">
                            <span>{{ $t('Submit') }}</span>
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "ForgotPasswordPage",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            password: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Password") }))
                .min(6, this.$t("Password must be at least 6 characters!")),
            confirmPassword: yup
                .string()
                .oneOf([yup.ref("password"), null], this.$t("Passwords must match!")),
        });

        return {
            initialValues: {
                resetToken: '',
                password: '',
            },
            countdown: 0,
            loading: false,
            schema,
            iconToggle: "eye",
            iconToggleConfirm: "eye",
        };
    },
    created() {
        if (this.$route.query.resetToken && this.$route.query.resetToken !== "") {
            this.initialValues.resetToken = this.$route.query.resetToken;
        } else {
            this.goBack();
        }
    },
    mounted() {
        if (this.$route.query.changePassword) {
            document.getElementById("header-title").innerHTML = this.$t("Change Password");
        }
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    methods: {
        goBack() {
            if (this.loggedIn) {
                this.$router.push("/profile");
            } else {
                this.$router.push("/login");
            }
        },
        togglePassword() {
            //element by name password
            var password = this.$el.querySelector("input[name='password']");
            if (password.type === "password") {
                password.focus();
                password.type = "text";
                this.iconToggle = "eye-slash";
            } else {
                password.focus();
                password.type = "password";
                this.iconToggle = "eye";
            }
        },
        toggleConfirmPassword() {
            //element by name password
            var confirmPassword = this.$el.querySelector("input[name='confirmPassword']");
            if (confirmPassword.type === "password") {
                confirmPassword.focus();
                confirmPassword.type = "text";
                this.iconToggleConfirm = "eye-slash";
            } else {
                confirmPassword.focus();
                confirmPassword.type = "password";
                this.iconToggleConfirm = "eye";
            }
        },
        handleRegister(user) {
            let loader = this.$loading.show();

            this.$store.dispatch("auth/resetPassword", user).then(
                (data) => {
                    this.$vueAlert.alert(data.message, null, 'success').then(() => {
                        this.goBack();
                    });
                    loader.hide();
                },
                (error) => {
                    this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    loader.hide();
                }
            );
        },
    },
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.button-container {
    max-width: 375px;
    margin: 0 auto 15px;
    margin-top: 50px;

    @media screen and (max-width: 600px) {
        margin-top: 25px;
        padding-left: 15px;
    }
}

.card-container.card {
    max-width: 375px !important;
    padding: 40px 40px;
}

.card {
    background-color: #fff;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    /* margin-top: 50px; */
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
